<template>
  <van-tabbar route>
  <van-tabbar-item replace to="/" icon="passed">申请</van-tabbar-item>
  <van-tabbar-item replace to="/about" icon="warning-o">说明</van-tabbar-item>
</van-tabbar>
</template>